import React from 'react';
import './Team.scss';

const Team = () => {
  return (
    <section
      className='team'
      id='team'>
      <div className='container team__wrapper'>
        <div className='team__image'>
          <img
            src='./img/hero-img.jpg'
            alt='Professionelles Reinigungsteam'
          />
        </div>

        <div className='team__content'>
          <h2>
            <span>Seit über 6 Jahren</span> steht unser Unternehmen für
            Zuverlässigkeit, Qualität und Vertrauen in der professionellen
            Reinigung
          </h2>

          <div className='team__text'>
            <p>
              Gegründet im Jahr 2020, haben wir uns von einem kleinen lokalen
              Dienstleister zu einem etablierten Reinigungsunternehmen
              entwickelt, das heute zahlreiche Privat- und Geschäftskunden
              betreut. Unsere Philosophie ist einfach – saubere Räume schaffen
              klare Gedanken.
            </p>

            <p>
              Wir setzen auf moderne Technologien, umweltfreundliche
              Reinigungsmittel und ein engagiertes Team von Fachkräften, das
              seine Arbeit mit Leidenschaft und Präzision ausführt. Jeder
              Auftrag ist für uns eine Verpflichtung, das Vertrauen unserer
              Kunden zu rechtfertigen – Tag für Tag.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Team;
